import { render, staticRenderFns } from "./StoriesArticleIllustratedMain.vue?vue&type=template&id=6d3fca26&scoped=true&"
import script from "./StoriesArticleIllustratedMain.vue?vue&type=script&lang=js&"
export * from "./StoriesArticleIllustratedMain.vue?vue&type=script&lang=js&"
import style0 from "./StoriesArticleIllustratedMain.vue?vue&type=style&index=0&id=6d3fca26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3fca26",
  null
  
)

export default component.exports